/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkBestPracticeRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkBestPracticeRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkBestPracticeRequest>): WellArchitectedFrameworkBestPracticeRequest {
        let obj = Object.assign(new WellArchitectedFrameworkBestPracticeRequest(), model);
        WellArchitectedFrameworkBestPracticeRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkBestPracticeRequest>): WellArchitectedFrameworkBestPracticeRequest {
        if (!model) return null;
        return WellArchitectedFrameworkBestPracticeRequest.newInstance(<WellArchitectedFrameworkBestPracticeRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkBestPracticeRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkBestPracticeRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkBestPracticeRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkBestPracticeRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.best_practices) {
            for (let val of this.best_practices) {
                models.WellArchitectedFrameworkBestPractice.fixupPrototype(val);
            }
        }
    }

    /**
     * Best Practices to process
     */
    best_practices: Array<models.WellArchitectedFrameworkBestPractice>;

}
